import { render, staticRenderFns } from "./choose-area.vue?vue&type=template&id=f44df606&"
import script from "./choose-area.vue?vue&type=script&lang=js&"
export * from "./choose-area.vue?vue&type=script&lang=js&"
import style0 from "./choose-area.vue?vue&type=style&index=0&id=f44df606&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports